import { render, staticRenderFns } from "./CollectionRun.vue?vue&type=template&id=5c0a0c75&"
import script from "./CollectionRun.vue?vue&type=script&lang=js&"
export * from "./CollectionRun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CollectionRun.vue"
export default component.exports